import React, { useContext, useEffect, useRef, useState } from 'react';
import hash from 'object-hash';
import cn from 'classnames';

import i18nContext from '@components/i18n/i18nContext';
import { Body } from '@common/components';
import { Button } from '@common/components';
import { useHeaderFooter } from '@hooks';
import styles from './Cookies.module.scss';

export const Cookies = () => {
  const { data, cookiesBlock } = useHeaderFooter();
  const legalPages = data.allNodeLandingPage.nodes;
  const { lng } = useContext(i18nContext);
  const legalUpdateHash = hash(legalPages.map(node => node.created));
  const [hidden, setHidden] = useState(true);
  const wrapRef = useRef();
  const overlayRef = useRef();
  const verticalOffset = '0px'; //64px
  const setOverlaysHeight = () => {
    overlayRef.current.style.height =
      window.innerWidth >= 1200 ? verticalOffset : 0;
  };

  const setHeadersHeight = () => {
    const header = document.getElementById('global-header');
    if (header) {
      header.style.top =
        window.innerWidth >= 1200 && !hidden ? verticalOffset : 0;
    }
  };

  const setBottomSpacing = height => {
    document.querySelector('body').style.marginBottom = height + 'px';
    const cookieMargin = document.getElementById('cookieMargin');
    if (cookieMargin) {
      cookieMargin.style.marginBottom = height + 'px';
    }
    const cookiePadding = document.getElementById('cookiePadding');
    if (cookiePadding) {
      cookiePadding.style.paddingBottom = height + 'px';
    }
  };

  const handleClick = () => {
    localStorage.setItem(`cookies.${lng}`, legalUpdateHash);
    setHidden(true);
    setBottomSpacing(0);
  };

  useEffect(() => {
    setHidden(localStorage.getItem(`cookies.${lng}`) === legalUpdateHash);

    setOverlaysHeight();
    window.addEventListener('resize', setOverlaysHeight, false);
    return () => {
      window.removeEventListener('resize', setOverlaysHeight, false);
    };
  }, []);

  useEffect(() => {
    setHeadersHeight();
    if (!hidden) {
      const cookieHeight = document.getElementById('cookieHeight').clientHeight;
      cookieHeight ? setBottomSpacing(cookieHeight) : setBottomSpacing(64);
    }
    window.addEventListener('resize', setHeadersHeight, false);
    return () => {
      window.removeEventListener('resize', setHeadersHeight, false);
    };
  }, [hidden]);

  return (
    <div
      className={cn(styles.overlay, { [styles.hidden]: hidden })}
      ref={overlayRef}
    >
      <div id="cookieHeight" className={styles.wrap} ref={wrapRef}>
        <div>
          <Body>{cookiesBlock.body && cookiesBlock.body.processed}</Body>
        </div>
        <div>
          <Button className={styles.btn} type="primary" onClick={handleClick}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

Cookies.propTypes = {};
